import { get } from 'lodash';

export const enableCAICSwitchToStandalone = get(window, 'newBillingConfig.enableCAICSwitchToStandalone', false);

export const enableCAICPlanRebranding = get(window, 'newBillingConfig.enableCAICPlanRebranding', false); // two products: AI companion & custom AI companion rebranding
